// extracted by mini-css-extract-plugin
export default {"container":"side_container__8YAHS","logo":"side_logo__9KOZD","active":"side_active__NRQGa"};